import { useTranslation } from 'react-i18next';
import { useAtom } from 'jotai';
import { HistoryFilterByEnum } from 'src/types';
import { historyFilterByAtom } from 'src/store';

type Props = {
  handleClick: () => void;
  showLabel: boolean;
  isMobile?: boolean;
};

export const FilterPersonalItems = ({
  handleClick,
  showLabel,
  isMobile = false,
}: Props) => {
  const [filterBy, setFilterBy] = useAtom(historyFilterByAtom);

  const { t } = useTranslation();

  return (
    <div className='flex w-full flex-col items-start gap-2'>
      {showLabel && (
        <div className='inline-flex w-full justify-between p-3 pb-0 pt-0'>
          <span className='whitespace-nowrap font-secondary text-primary-dark'>
            {t('history.filters.personal_label')}:
          </span>
        </div>
      )}
      <div
        className={`${showLabel ? 'pb-4 pl-6 pt-0' : 'py-3 pl-3'} ${isMobile ? '' : 'py-4 pl-6'} flex w-full flex-col items-start justify-center gap-2 pr-4`}
      >
        {Object.keys(HistoryFilterByEnum).map((filter, i) => (
          <button
            key={`filter-${i}`}
            className={`w-full whitespace-nowrap py-0.5 text-left font-semibold transition-all ${
              filterBy === filter
                ? 'text-primary-dark hover:text-primary'
                : 'text-primary hover:text-primary-dark'
            }`}
            name={filter}
            onClick={(e) => {
              setFilterBy(
                e.currentTarget.name as keyof typeof HistoryFilterByEnum,
              );
              handleClick();
            }}
          >
            {t(`history.filters.${filter}`)}
          </button>
        ))}
      </div>
    </div>
  );
};
